export default __webpack_public_path__ + "static/media/5240.67272355.png";